import { Component, OnInit, ViewChild } from '@angular/core';
import { HereJsService } from '../../services/here-js.service';

@Component({
  selector: 'app-entity',
  templateUrl: './entity.component.html',
  styleUrls: ['./entity.component.scss'],
})
export class EntityComponent implements OnInit {

  items; data;
  ctrl;

  active: any = {};

  query: string = '';

  public qResults = new Array<any>();

  public acs = [];

  result: any = {};

//   @ViewChild('i', {static:true})i: any;
  
  constructor(
    private ac: HereJsService,
  ) {
  }

  ngOnInit() {}
  
  ngAfterViewInit() {
    // setTimeout(() => {
    //   this.i.setFocus()
    // }, 300);
  }









  
  async search(){
    let l = this.query.trim().length;
    if(!l || (l > 15 && l % 3 !== 0)) return;
    if(l < 5){
      this.qResults = [{description: 'Searching...'}]
    } else {
      let p = await this.ac.predict(this.query);
      return this.qResults = p;
    }
  }










  async set(r) {

    const func = this.items?.return||'address';
    let {address, displayPosition} = await this.ac[func](r);
    
    this.result.address = address?.label;
    this.result.loc = {
      coords: displayPosition,
      address
    }
    
    this.query = this.result?.address;

    this.active.query = false;
  }










  reset() {
    this.query = '';
    this.active.query = true;
  }










  async close(r?) {
    await this.ctrl.dismiss(r||this.result)
  }

}
